import { ViewType } from '~/models/shared/types'
import { SearchConfig } from '~/models/search/config'
import { CategoryId } from '~/models/category/types'

export const jobsSearchConfig: SearchConfig = Object.freeze({
  settings: {
    searchName: 'jobs',
    viewType: {
      defaultViewTypeMobile: ViewType.LIST,
      defaultViewTypeDesktop: ViewType.LIST
    },
    searchbar: {
      autocompleteEndpoint: '/api/classifieds/query/',
      usesNuxtLinks: false
    },
    isJobsSearch: true,
    displayAds: true
  },
  rootParams: {
    category: [CategoryId.JOBS]
  }
})
